import createAxiosInstance from "../axiosInstance";

class RecruitRepositoryV1 {
  constructor() {
    this.baseUrl = process.env.REACT_APP_API_RECRUIT_V1;
    this.apiClient = createAxiosInstance(this.baseUrl);
  }

  /**
   * 채용 공고 목록 조회
   * @param {*} query :{
   *  page?: number,
   *  limit?: number, //검색어 (제목, 설명 등)
   *  search?: string, //검색 키워드 (제목, 내용, 요구사항 등)
   *  keyword?: string,
   *  status?: '모집 중' | '마감됨' | '초안' | '모집 준비 중' | '수정 불가',
   *  startDate?: string,
   *  endDate?: string,
   *  careerLevel?: '신입' | '경력' | '무관',
   *  recruitmentType?: 'regular' | 'period' | 'all',
   *  sortBy?: 'title' | 'workLocation' | 'status' | 'postedDate' | 'endDate' | 'createdAt' | 'updatedAt' | 'enrolledApplicants',
   *  order?: 'asc' | 'desc',
   * }
   * @returns
   */
  async getRecruitList(query) {
    const response = await this.apiClient.get(
      `${this.baseUrl}/api/public/recruitments`,
      {
        params: query,
      }
    );
    return response;
  }

  async getRecruitDetail(id) {
    const response = await this.apiClient.get(
      `${this.baseUrl}/api/public/recruitment/${id}`
    );
    return response;
  }

  //   async getRecruitImage(id) {
  //     const response = await this.apiClient.get(
  //       `${this.baseUrl}/recruitment/${id}/document`,
  //       {
  //         responseType: "blob",
  //       }
  //     );
  //     return response.data;
  //   }

  //   async getRecruitImageUrl(id) {
  //     return `${this.baseUrl}/recruitment/${id}/document`;
  //   }

  /**
   * 채용 지원 임시 파일 업로드
   * @param {*} data
   * {
   *  name: string,
   *  email: string,
   *  phone: string,
   *  experienceType: '신입' | '경력',
   *  experienceYears: number,
   *  accessRoute: string,
   *  recruitmentId: string,
   *  isRequiredInfoAgreed: boolean,
   *  isOptionalInfoAgreed: boolean,
   *  isSensitiveInfoAgreed: boolean,
   *  tempResumeUrl: string,
   *  tempPortfolioUrl: string,
   * }
   * @returns
   */
  async applyRecruitWithTempFile(data) {
    const response = await this.apiClient.post(
      `${this.baseUrl}/api/public/application`,
      data
    );
    return response;
  }

  /**
   * 채용 지원 임시 파일 업로드 URL 발급
   * @param {*} data
   * {
   *  fileName: string,
   *  fileType: 'resume' | 'portfolio',
   * }
   * @returns
   */
  async postFileTempUploadUrl(data) {
    const response = await this.apiClient.post(
      `${this.baseUrl}/api/public/application/upload-url`,
      data
    );
    return response;
  }

  /**
   * 채용 전형 접근 경로 조회
   * @param {*} type :{
   *  type: 'APPLICANT_ACCESS' | 'INTERNAL_SYSTEM,
   * }
   * @returns
   */
  async getApplyAccessRoutes() {
    const response = await this.apiClient.get(
      `${this.baseUrl}/api/public/access-routes`
    );
    return response;
  }

  async uploadFileToS3(file, uploadUrl) {
    await this.apiClient.put(uploadUrl, file, {
      headers: {
        "Content-Type": file.type,
      },
    });
  }
}

const recruitRepositoryV1 = new RecruitRepositoryV1();

export default recruitRepositoryV1;
